// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3uYq8","inputDescription":"styles_inputDescription__3cgfp"};